// AES解密相关导入
import CryptoJS from 'crypto-js';



const ENCRYPT_SECRET_KEY = 'aJt0KvXe9RpDbL6mXz1qPsTgUyWcFvBn';

/**
 * 校验中国大陆手机号
 * @param phoneNumber - 需要校验的手机号
 * @returns 是否为有效的手机号
 */
export function validatePhoneNumber(phoneNumber: string): boolean {
    // 全球手机号正则表达式
    const phoneRegex = /^(?:\+?\d{1,3})?[0-9]{10,}$/;
    return phoneRegex.test(phoneNumber);
}



export function getMarkDownHeadings(markdown: string): Heading[] {
    const headingRegex = /^(#+\s)([^#][^=].*?(?=\n[^#]|\n\s*#{1,6}\s|$))/gs;
    const linkRegex = /\[([^\]]+)\]\([^\)]+\)/g;
    let match;
    const headings: Heading[] = [];

    while ((match = headingRegex.exec(markdown))) {
        let title = match[2].replace(linkRegex, (match, p1) => p1);

        headings.push({ level: match[1].length, title: title });
    }

    return headings;
}


export function image(url?: string, size?: number) {
    if (!url) return ''
    url = obs(url)
    if (!size) return url;
    if (url && url.includes('?')) return url
    return `${url}?imageMogr2/thumbnail/${size}x>`
}

export function oss(url: string) {
    return `${import.meta.env.VITE_OSS_URL}/${url}`
}

/**
 * 获取网站子域名
 * @returns 
 */
export function getWebsite() {
    const host = window.location.host;
    const website = host.split('.')[0];
    const site = website.split(':')[0]
    // return 'de'
    return site;
}

/** 复习相关请求统一带上 website，确保按站点隔离用户计划数据 */
export function withReviewWebsite<T extends Record<string, unknown>>(body: T): T & { website: string } {
    return { ...body, website: getWebsite() };
}


/**
 * 判断是在iframe中
 */
export function isIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
/**
 * 判断是否电脑端
 */
export function isPC() {
    const userAgentInfo = navigator.userAgent;
    const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
        }
    }
    return flag;
}

/**
 * 节流函数
 * @param func 
 * @param wait 
 * @returns 
 */
export function throttle(func: Function, wait: number) {
    let previous = 0;
    return function (this: any) {
        let now = Date.now();
        if (now - previous > wait) {
            func.apply(this, arguments);
            previous = now;
        }
    };
}


/**
 * 防抖函数
 * @param func 
 * @param wait 
 * @returns 
 * 
 */
export function debounce<T extends (...args: any[]) => any>(func: T, wait: number): (...args: Parameters<T>) => void {
    let timeout: ReturnType<typeof setTimeout> | null = null;

    return function (this: any, ...args: Parameters<T>) {
        const context = this;
        if (timeout !== null) clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
}
export const compressImage = (imageUrl: string, maxWidth: number = 100, maxHeight: number = 100): Promise<Blob | null> => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = imageUrl;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const MAX_WIDTH = maxWidth; // 设置最大宽度
            const MAX_HEIGHT = maxHeight; // 设置最大高度
            let width = img.width;
            let height = img.height;

            // 计算新的宽高比
            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }

            canvas.width = width;
            canvas.height = height;
            if (ctx) {
                ctx.drawImage(img, 0, 0, width, height);
                canvas.toBlob(blob => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        console.error('Failed to convert canvas to blob.');
                        resolve(null);
                    }
                })

            } else {
                console.error('Failed to get the 2D drawing context for the canvas.');
                resolve(null);
            }
        };
    });
};

/**
 * 
 * @returns 获取子域名
 */
export function getSubdomain() {
    const hostname = window.location.hostname;

    // 分割hostname得到各个部分，例如 "sub.example.com" => ["sub", "example", "com"]
    const parts = hostname.split('.');

    // 检查是否至少有3个部分（子域名、主域名、顶级域名）
    return parts[0]
}



function replaceBrackets(str: string) {
    // 使用正则表达式全局替换 ( 为 （
    str = str.replace(/\(/g, '（');
    // 使用正则表达式全局替换 ) 为 ）
    str = str.replace(/\)/g, '）');
    return str;
}
function parseString(input: string) {
    // 先尝试匹配括号格式："会議（かいぎ）"
    const bracketRegex = /(.*?)（(.*?)）/;
    const bracketMatch = bracketRegex.exec(input);

    if (bracketMatch) {
        return [bracketMatch[1].trim(), bracketMatch[2].trim()];
    }

    // 再尝试匹配斜杠格式："гость / гостья" 或 "гость/гостья"
    // 仅当字符串中恰好只有一个 "/" 时才按斜杠拆分
    // 多个 "/" 说明斜杠是词内结构标记（如德语 "der/die Schiedsrichter/in"），不应拆分
    const slashCount = (input.match(/\//g) || []).length;
    if (slashCount === 1) {
        const slashRegex = /(.+?)\s*\/\s*(.+)/;
        const slashMatch = slashRegex.exec(input);

        if (slashMatch) {
            return [slashMatch[1].trim(), slashMatch[2].trim()];
        }
    }

    // 如果都不匹配，返回原字符串
    return [input.trim()];
}

export function compareStrings(str1: string, str2: string): boolean {
    // 统一替换各种波浪号变体为标准波浪号 '~'
    const normalizeWavyDash = (str: string): string => {
        return str.replace(/[〜∼∾～]/g, '~');
    };

    // 判断是否包含日语字符（平假名、片假名、汉字）
    const containsJapanese = (str: string): boolean => {
        return /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]/.test(str);
    };

    // 判断是否包含越南语字符（含越南语专有字母及扩展字符）
    // 越南语听写要求重音必须完全正确，不能做去重音容错。
    const containsVietnamese = (str: string): boolean => {
        return /[đăâêôơư\u1EA0-\u1EF9]/i.test(str);
    };

    // 去除拉丁字母和俄文字母的重音符号
    // 注意：不应用于日语假名、越南语（越南语需要严格匹配重音）
    const removeDiacritics = (str: string): string => {
        // 如果字符串包含日语或越南语字符，直接返回原字符串
        if (containsJapanese(str) || containsVietnamese(str)) {
            return str;
        }
        // 移除所有组合附标和常见的独立重音符号（例如 ´ ˊ ˋ ˆ）
        try {
            return str
                .normalize('NFD')
                .replace(/\p{M}+/gu, '') // 所有组合附标
                .replace(/[\u00B4\u02CA\u02CB\u02C6]/g, ''); // 常见独立重音符
        } catch {
            // 兼容不支持 normalize 的环境
            return str.replace(/[\u0300-\u036f\u00B4\u02CA\u02CB\u02C6]/g, '');
        }
    };

    // 预处理字符串：替换括号和波浪号，并转换为小写
    // 将常见的拉丁-西里尔外形相似字母统一到西里尔字母，避免重音标记输入成拉丁字母后无法匹配
    const normalizeCyrillicLookalikes = (str: string): string => {
        // 仅当字符串中出现西里尔字符时才进行转换，避免误伤纯英文
        if (!/[\u0400-\u04FF]/.test(str)) return str;
        const map: Record<string, string> = {
            // 元音
            a: 'а', e: 'е', o: 'о', y: 'у',
            // 常见辅音
            c: 'с', x: 'х', p: 'р', k: 'к', h: 'һ', m: 'м', t: 'т'
        };
        return str.replace(/[aceopxykhmt]/g, (ch) => map[ch] || ch);
    };

    // 德语：ß 与 ss 等价（听写时写成 gross 也算对 groß）
    const normalizeGermanEszett = (str: string): string => {
        return str.replace(/\u00DF/g, 'ss').replace(/\u1E9E/g, 'ss'); // ß、ẞ → ss
    };

    const normalizedStr1 = normalizeCyrillicLookalikes(
        normalizeGermanEszett(removeDiacritics(normalizeWavyDash(replaceBrackets(str1 || '')).toLowerCase()))
    );
    const normalizedStr2 = normalizeCyrillicLookalikes(
        normalizeGermanEszett(removeDiacritics(normalizeWavyDash(replaceBrackets(str2 || '')).toLowerCase()))
    );

    // 只要任意一侧包含日语，就认为是日语模式
    const isJapaneseMode = containsJapanese(normalizedStr1) || containsJapanese(normalizedStr2);

    // 创建去除波浪号的版本，用于支持"没有输入波浪号也算对"的需求
    const str1WithoutTilde = normalizedStr1.replace(/~/g, '');
    const str2WithoutTilde = normalizedStr2.replace(/~/g, '');

    const arr1 = parseString(normalizedStr1);
    const arr2 = parseString(normalizedStr2);

    // 如果去除波浪号后的字符串相同，也算匹配
    if (str1WithoutTilde === str2WithoutTilde) {
        return true;
    }

    // 解析去除波浪号后的字符串
    const arr1WithoutTilde = parseString(str1WithoutTilde);
    const arr2WithoutTilde = parseString(str2WithoutTilde);

    // 检查去除波浪号后的版本是否匹配
    if (arr1WithoutTilde.length == 2 && arr2WithoutTilde.length == 2) {
        if (arr1WithoutTilde[0] == arr2WithoutTilde[0] && arr1WithoutTilde[1] == arr2WithoutTilde[1]) {
            return true;
        }
        // 双方都给出两部分时（如 "word（annotation）" 或 "word1 / word2"），要求两部分都完全匹配
        return false;
    }
    // 并非双方都提供两种形式时，保留“任一正确即可”的宽松逻辑（如只输入了其中一种形式）
    if (arr1WithoutTilde.includes(arr2WithoutTilde[0]) || arr2WithoutTilde.includes(arr1WithoutTilde[0])) {
        return true;
    }
    if (arr1WithoutTilde.length > 1 && arr2WithoutTilde.length > 1) {
        if (arr1WithoutTilde.includes(arr2WithoutTilde[1]) || arr2WithoutTilde.includes(arr1WithoutTilde[1])) {
            return true;
        }
    }

    // 原有的比较逻辑（包含波浪号的版本）
    if (arr1.length == 2 && arr2.length == 2) {
        // 双方都给出两部分时，要求两部分都完全匹配
        return arr1[0] == arr2[0] && arr1[1] == arr2[1];
    }
    // 有一侧只有单一形式时，继续使用“任一正确即可”的宽松逻辑
    if (arr1.includes(arr2[0]) || arr2.includes(arr1[0])) return true;
    if (arr1.includes(arr2[1]) || arr2.includes(arr1[1])) return true;

    return false;
}

export function UUID() {
    return Math.random().toString(36).slice(2, 11);
}

export function textToVoice(text: string, lang: string) {
    const dict: any = {
        // ja: 'ja-JP-MayuNeural',
        ja: 'Microsoft Server Speech Text to Speech Voice (ja-JP, KeitaNeural)',
        ko: 'Microsoft Server Speech Text to Speech Voice (ko-KR, SunHiNeural)',
        han: 'Microsoft Server Speech Text to Speech Voice (ko-KR, SunHiNeural)',
        // en: 'en-US-AvaNeural',
        en: 'Microsoft Server Speech Text to Speech Voice (en-AU, NatashaNeural)',
        // fr: 'fr-CH-ArianeNeural',
        fr: 'Microsoft Server Speech Text to Speech Voice (fr-BE, CharlineNeural)',
        // de: 'de-DE-AmalaNeural',
        // de: 'Microsoft Server Speech Text to Speech Voice (de-DE, SeraphinaMultilingualNeural)',
        de: 'Microsoft Server Speech Text to Speech Voice (de-DE, KatjaNeural)',
        // spain: 'es-AR-ElenaNeural',
        spain: 'Microsoft Server Speech Text to Speech Voice (es-AR, ElenaNeural)',
        // ru: 'ru-RU-SvetlanaNeural',
        ru: 'Microsoft Server Speech Text to Speech Voice (ru-RU, SvetlanaNeural)',
        'zh-HK': 'Microsoft Server Speech Text to Speech Voice (zh-HK, WanLungNeural)',
        it: 'Microsoft Server Speech Text to Speech Voice (it-IT, GiuseppeMultilingualNeural)',
        th: 'Microsoft Server Speech Text to Speech Voice (th-TH, PremwadeeNeural)',
        vi: 'Microsoft Server Speech Text to Speech Voice (vi-VN, HoaiMyNeural)',
        zh: 'Microsoft Server Speech Text to Speech Voice (zh-CN, XiaoxiaoNeural)'
    }

    // 提取括号内的文本
    const bracketRegex = /[(\（]([^)）]+)[)\）]/;
    const match = text.match(bracketRegex);
    const processedText = match ? match[1] : text;

    // return `http://localhost:8003/tts?text=${processedText}&voice=${dict[lang]}`
    // return `https://tts.jiaojq.vip/tts?text=${processedText}&voice=${dict[lang]}&cache_type=permanent`
    return `https://www.jiaojq.vip/api/app/chat/info/tts?text=${processedText}&voice=${dict[lang]}&ok=1`
    // return `http://localhost:8001/app/chat/info/tts?text=${processedText}&voice=${dict[lang]}`

    return `https://dict.youdao.com/dictvoice?audio=${processedText}&le=${lang}`
    // return `https://fanyi.baidu.com/gettts?lan=${dict[lang]}&text=${processedText}&spd=3`
}

export function obs(url?: string) {
    if (!url) return ''
    if (!url.includes('http')) return 'https://minio.jiaojq.vip' + url
    return url.replace('obs.jiaojq.vip', 'minio.jiaojq.vip')
}



// 获取地址栏参数
export function getUrlParam(name: string): string | null {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}

// 增强版URL参数获取函数，支持多种方式获取code
export function getCodeFromUrl(): string | null {
    try {
        console.log('开始获取code参数，当前URL:', window.location.href);
        console.log('设备信息:', {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            cookieEnabled: navigator.cookieEnabled
        });

        // 1. 从查询参数获取
        const queryCode = getUrlParam('code');
        if (queryCode) {
            console.log('从查询参数获取到code:', queryCode);
            return queryCode;
        }

        // 2. 从hash参数获取
        const hash = window.location.hash;
        if (hash) {
            const hashParams = new URLSearchParams(hash.substring(1));
            const hashCode = hashParams.get('code');
            if (hashCode) {
                console.log('从hash参数获取到code:', hashCode);
                return hashCode;
            }
        }

        // 3. 从完整URL中解析
        const url = new URL(window.location.href);
        const urlCode = url.searchParams.get('code');
        if (urlCode) {
            console.log('从URL对象获取到code:', urlCode);
            return urlCode;
        }

        // 4. 从路径参数获取（如果code在路径中）
        const pathParts = window.location.pathname.split('/');
        const codeIndex = pathParts.findIndex(part => part === 'code');
        if (codeIndex !== -1 && pathParts[codeIndex + 1]) {
            const pathCode = pathParts[codeIndex + 1];
            console.log('从路径参数获取到code:', pathCode);
            return pathCode;
        }

        // 5. 兼容性处理：某些设备可能URL编码有问题，尝试解码
        const fullUrl = window.location.href;
        const codeMatch = fullUrl.match(/[?&]code=([^&]*)/);
        if (codeMatch && codeMatch[1]) {
            const decodedCode = decodeURIComponent(codeMatch[1]);
            console.log('从正则匹配获取到code:', decodedCode);
            return decodedCode;
        }

        console.warn('未找到code参数，URL结构:', {
            href: window.location.href,
            search: window.location.search,
            hash: window.location.hash,
            pathname: window.location.pathname
        });
        return null;
    } catch (error) {
        console.error('获取code参数时出错:', error);
        return null;
    }
}

/**
 * 将分转换为元
 * @param fen 分值
 * @returns 元值
 */
export const fenToYuan = (fen: number, removeInvalidDecimals = false): string => {
    const value = (fen / 100).toFixed(2)
    // 如果需要移除无效小数点，且小数点后都是0，则去除小数部分
    if (removeInvalidDecimals && /\.\d*?0+$/.test(value)) {
        return parseFloat(value).toString()
    }
    return value
}

export const sleep = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * AES解密函数
 * @param encryptedText 加密后的字符串（格式: iv:encrypted）
 * @returns 解密后的数据
 */
export function decryptAES(encryptedText: string): any {
    try {
        // 分割IV和加密数据
        const parts = encryptedText.split(':');
        if (parts.length !== 2) {
            throw new Error('无效的加密数据格式');
        }

        const ivHex = parts[0];
        const encryptedHex = parts[1];
        const key = CryptoJS.enc.Utf8.parse(ENCRYPT_SECRET_KEY.slice(0, 32).padEnd(32, '0'));

        // 将hex字符串转换为CipherParams格式
        const encrypted = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Hex.parse(encryptedHex)
        });

        // 使用CryptoJS进行AES解密
        const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
            iv: CryptoJS.enc.Hex.parse(ivHex),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        // 将解密结果转换为UTF-8字符串
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

        if (!decryptedText) {
            throw new Error('解密失败，返回数据为空');
        }

        // 尝试解析为JSON对象
        try {
            return JSON.parse(decryptedText);
        } catch {
            // 如果不是JSON，直接返回字符串
            return decryptedText;
        }
    } catch (error) {
        console.error('AES解密失败:', error);
        throw error;
    }
}